"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const expertsSlice_1 = require("../../../../../../../redux/slices/expertsSlice");
const modalsSlice_1 = require("../../../../../../../redux/slices/modalsSlice");
require("./cvReference.scss");
const CvReference = (props) => {
    const { expert } = props;
    return expert ? (react_1.default.createElement(core_1.Paper, { className: 'paper admin-blocks cv-reference' },
        react_1.default.createElement("div", { className: "header-add" },
            react_1.default.createElement("h5", null, "CV & References"),
            react_1.default.createElement("div", { className: 'align-right' },
                react_1.default.createElement("div", { className: "profile-add-sec-license" }, "Add"))),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 3 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement("ul", { className: "cv-list" },
                    react_1.default.createElement("li", null, "must be cv file")))))) : (react_1.default.createElement(react_1.Fragment, null));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        expert: experts.editableExpert
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(CvReference);
